<template>
  <v-menu v-model="menu">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="{ ...attrs, ...$attrs }" v-on="on" :loading="loading">{{
        __("alterar utilizador EPS")
      }}</v-btn>
    </template>

    <v-list>
      <v-list-item
        v-for="user in users"
        :key="user.slug"
        @click="handleChangeUser(user)"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ user.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { updateEpsUser } from "@/services/eps.js";
import i18n from "@/mixins/i18n";

export default {
  mixins: [i18n],
  props: {
    lead_identifier_code: String,
  },

  data() {
    return {
      i18n_prefix: "integration",
      menu: false,
      loading: false,
      users: [
        {
          slug: "general",
          name: this.__("geral", "integration"),
        },
        {
          slug: "traditional_expertise",
          name: this.__("peritagem tradicional", "integration"),
        },
      ],
    };
  },

  methods: {
    async handleChangeUser(user) {
      this.menu = false;
      this.loading = true;

      await updateEpsUser({
        lead_identifier_code: this.lead_identifier_code,
        eps_user_slug: user.slug,
      });

      this.$emit("changed", user);

      this.loading = false;
    },
  },
};
</script>
